import React, { Fragment } from "react";
import styled from "styled-components";

import {createWebpageSection, StyledIndividualWrapper, StyledAnchorNames, StyledSectionContent, StyledText} from './styles';
import TimelineContainer from "./timelineContainer"
import LikesContainer from "./likesContainer"

import { TEXT_FONT, HEADER_FONT, ACCENT_YELLOW_COLOR, BACKGROUND_COLOR } from '../const'

const StyledContainer = styled.div` 
  width: 100%;
  height: 100%;
  display: flex;
  background-color: ${BACKGROUND_COLOR};
  flex-direction: column;
  align-content: baseline;
  overflow-y: scroll;
  overflow-x: hidden;
  font-family: ${HEADER_FONT};
`

const StyledLandingPage = styled.a`
  display: flex;
  justify-content: center;
  padding-top: 30vh;
  &:hover {
    text-decoration: none;
  }
`

const StyledLandingPageName = styled.span`
  font-size: 10vw; 
  background-color: ${ACCENT_YELLOW_COLOR};
  color: ${BACKGROUND_COLOR};
  font-family: ${TEXT_FONT};
  padding: 5px 15px;
`

const LandingPage = () => ( 
  <StyledIndividualWrapper isLandingPage={true}> 
    <StyledLandingPage name="home">
      <StyledLandingPageName>Jackie Ma</StyledLandingPageName>
    </StyledLandingPage>
  </StyledIndividualWrapper> 
)

const StyledSkillsContainer = styled.div`
  display: flex;
  background: white;
  padding-left: 1vw;
  padding-bottom: 1vh;
  color: ${BACKGROUND_COLOR};
`

const StyledSkillPane = styled.div`
  width: 50vw;
`

const StyledSubHeading = styled.div` 
  font-size: 3vw;
  padding-top: 10px;
`

const softwareToolsList = [
  {
    name: "Redux-Saga", 
    star: 4
  },
  {
    name: "ReactJS", 
    star: 4
  },
  {
    name: "AWS", 
    star: 3
  },
  {
    name: "Ruby on Rails", 
    star: 3
  }
]

const StyledItem = styled.div`
  display: flex;
  align-items: baseline;
  color: ${BACKGROUND_COLOR};
`
const StyledItemSpan = styled.span`
  padding-right: 10px;
`

const REGULAR_STAR = "far fa-star";
const FILLED_IN_STAR =  "fas fa-star";
const generateSkillSet = (list) => {

  const styledList = list.map((item) => {
    const maxStars = 5 
    const listOfStars = []

    for(let i = 0; i < maxStars;  i++){
      if (i < item.star) {
        listOfStars.push(<i key={`star-${i}`} className={FILLED_IN_STAR}/>)
      }
      else {
        listOfStars.push(<i key={`star-${i}`} className={REGULAR_STAR}/>)
      }
    }
    return (
      <StyledItem key={item.name}>
        <StyledItemSpan>{item.name}</StyledItemSpan> 
        <span>{listOfStars}</span>
      </StyledItem>
    )
  })    
  return styledList;
}

const listOfLanguages = [
  {
    name: "Javascript",
    star: 4
  },
  {
    name: "Ruby",
    star: 3
  },
  {
    name: "C#",
    star: 2
  },
  {
    name: "C++",
    star: 2
  }
]

const StyledItems = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 2vw; 
`

const Skills = () => {
  const content = (
    <StyledSkillsContainer>
      <StyledSkillPane>

        <StyledSubHeading>Certification</StyledSubHeading>
        <StyledItems>
          <span data-iframe-width="150" data-iframe-height="270" data-share-badge-id="eb46520f-fec2-40a6-9c31-3fdfc5f600c9" data-share-badge-host="https://www.credly.com"> Amazon Web Services Solutions Architect Associate </span>
          <script type="text/javascript" async src="//cdn.credly.com/assets/utilities/embed.js"></script>    
        </StyledItems>

        <StyledSubHeading>Languages:</StyledSubHeading>
        <StyledItems>
          {generateSkillSet(listOfLanguages)}
        </StyledItems>
        
        <StyledSubHeading>Software/Tools:</StyledSubHeading>
        <StyledItems>
          {generateSkillSet(softwareToolsList)}
        </StyledItems>

      </StyledSkillPane>
      
    </StyledSkillsContainer>)
  return createWebpageSection({anchorName: "skills", header: "Skills", content, background: BACKGROUND_COLOR })
}

export const HomepageContainer = () => {
  return (
    <StyledContainer>
      {/* <LandingPage/>         */}
      {/* <LikesContainer /> */}
      {/* <Skills /> */}
      <TimelineContainer />
    </StyledContainer>
  );
};

export default HomepageContainer;
